export default __webpack_public_path__ + "static/media/main-pic.68043f7e.png";